/**
 * @generated SignedSource<<44a0603834ce65c3b835d7fbda680d59>>
 * @relayHash 366493bce0870f14072134866977bff4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9d0606b2e31450e1baa37b4bc68759b41407dac4e2cceb25c7be76e1aecc916

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b9d0606b2e31450e1baa37b4bc68759b41407dac4e2cceb25c7be76e1aecc916",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
